import * as React from "react";
import {GridColDef} from "@mui/x-data-grid";
import {BtnType, ProTable} from "@/widget/ProTable/ProTable";
import {CertPageBO, CertPageVO} from "@/service/cnipa.s";
import {PatentPageVO, SyncPatentBO, useSyncPatent} from "@/service/patent.s";
import {PaginationCPCVO, PaginationVO} from "@/model/global";
import {formatTime, str2ArrBuff} from "@/helper/method";
import {get, isEmpty} from "lodash";
import {useEffect} from "react";
import {useGlobalActions} from "@/store/global.c";

export const CertListPage = () => {
    const [certPageData, setCertPageData] = React.useState<PaginationCPCVO<CertPageVO>>({} as PaginationCPCVO<CertPageVO>)
    const {setToast} = useGlobalActions()
    const {mutateAsync: syncPatentMutate} = useSyncPatent()

    const columns: GridColDef<CertPageVO>[] = [
        {field: "zhuanlisqh", headerName: "申请号", flex: 0.68},
        {field: "certName", headerName: "证书名称", flex: 0.5},
        {
            field: "zhuanlimc",
            headerName: "发明名称",
            headerAlign: "left",
            align: "left",
            flex: 0.8
        },
        {
            field: "gonggaoDate",
            headerName: "授权公告日",
            headerAlign: "center",
            align: "center",
            flex: 0.6,
            valueFormatter: (value: string) => formatTime("D", value),
        },
        {
            field: "gonggaoh",
            headerName: "授权公告号",
            flex: 0.6,
        },
        {
            field: "zhuanliqr",
            headerName: "专利权人",
            flex: 0.8,
        },
        {
            field: "fawenxlh",
            headerName: "发文序列号",
            flex: 0.6,
        },
        {
            field: "fawenDate",
            headerName: "发文日期",
            headerAlign: "center",
            align: "center",
            flex: 0.55,
            valueFormatter: value => formatTime("D", value),
        },
    ];

    useEffect(() => {
        window.addEventListener("message", listenerMessage)
        return () => window.removeEventListener("message", listenerMessage)
    }, []);

    const listenerMessage = async (event: MessageEvent) => {
        if (event?.data?.type == 'ResultCertPage') {
            setCertPageData(event?.data?.data);
        }
        if (event?.data?.type == 'ResultSyncCert') {
            const certs = event?.data?.data;
            for (const key in certs) {
                const cert: SyncPatentBO = certs[key];
                const formData = new FormData();
                const blob = str2ArrBuff(cert.file)
                const file = new File([blob], `${cert.remark}.pdf`, {
                    type: "pdf",
                });
                formData.append("file", file);
                formData.append("applyNo", cert.applyNo);
                formData.append("isSave", "1");
                formData.append("tag", "20");
                formData.append("remark", cert.remark);
                formData.append("extra", JSON.stringify(cert.extra));
                await syncPatentMutate({
                    formData, onUploadProgress: (event) => {
                    }
                });
            }
            setToast({message: `同步数据完成`, open: true, severity: 'success', variant: 'standard', duration: 3})
        }
        if (event?.data?.type == 'LoadingComplete') {
            if (isEmpty(certPageData)) {
                window.postMessage(({
                    type: "QueryCertPage", data: {}
                }))
            }
        }
    }

    const btnCallback = async ({btn, keys, rows, onSearch}: BtnType<CertPageVO>) => {
        if (btn.alias == 'sync') {
            if (rows.length > 0 && rows.length <= 30) {
                setToast({message: `开始同步${keys.length}条数据`, open: true, severity: 'success', variant: 'standard', duration: 3})
                window.postMessage(({
                    type: "SyncCert", data: rows
                }))
            } else {
                setToast({message: "请选择一至三十条数据", open: true, severity: 'warning', variant: 'standard'})
            }
        }
    }

    return (
        <ProTable<CertPageVO>
            loading={false}
            showSearch={false}
            columns={columns}
            btnCallback={btnCallback}
            drawerProps={{
                view: {
                    viewBtnCallback: (row: PatentPageVO) => {
                        return {businessId: row.id, instanceId: row.instanceId}
                    }
                }
            }}
            rowId={"fid"}
            data={{...certPageData, list: certPageData?.records || []} as PaginationVO<CertPageVO>}
            onSearch={({postDate, ...rest}: CertPageBO) => {
                window.postMessage(({
                    type: "QueryCertPage", data: {
                        ...rest, fawenrStart: get(postDate, '[0]', ''),
                        fawenrEnd: get(postDate, '[1]', '')
                    }
                }))

                // certPageMutate({
                //     ...rest, fawenrStart: get(postDate, '[0]', ''),
                //     fawenrEnd: get(postDate, '[1]', '')
                // });
            }}
            code={"patent_cert"}
        />
    );
};
